export class DocumentVersion {
  public id: string;
  public documentId: string;
  public version: string;
  public fileName: string;
  public extension?: string;
  public hashMd5?: string;
  public sizeKb: number;
  public description?: string;
  public creatorId?: string;
  public created: string; // ($date - time)
}
